<template>
    <div class="flex flex-col h-screen justify-between">
        <header class="z-50 fixed top-0 w-full">
            <router-view name="header" class="relative"></router-view>
        </header>
        <main :class="isAuthRoute ? '' : 'mb-auto mt-12 md:mt-52'">
            <router-view name="default" v-slot="slotProps">
                <component :is="slotProps.Component"></component>
            </router-view>
        </main>
        <router-view name="footer"></router-view>
    </div>
</template>

<script>
export default {
    name: "App",
    computed: {
        didAutoLogout() {
            return this.$store.getters.didAutoLogout;
        },
        // Sulle route pubbliche di auth AuthShell centra da solo (min-h-screen):
        // niente offset dall'header, altrimenti il box scende troppo.
        isAuthRoute() {
            const p = this.$route.path || '';
            return p.startsWith('/login')
                || p.startsWith('/forgot-password')
                || p.startsWith('/reset-password');
        },
    },
    created() {
        // Non tentare la sessione sulle route pubbliche di auth (evita 401 → loop).
        // window.location.pathname (non this.$route.path): su hard-load il router
        // potrebbe non aver ancora risolto la rotta iniziale.
        const path = window.location.pathname;
        const onAuthRoute = path.startsWith('/login')
            || path.startsWith('/forgot-password')
            || path.startsWith('/reset-password');
        if (!onAuthRoute) {
            this.$store.dispatch("tryLogin");
        }
    },
    watch: {
        didAutoLogout(curValue, oldValue) {
            if (curValue && curValue !== oldValue) {
                // Sessione persa → redirect a /login
                this.$router.push('/login');
            }
        },
    },
};
</script>

<style>
body {
    @apply bg-gray-100;
}

.route-enter-from {
    opacity: 0;
}

.route-leave-to {
    opacity: 0;
}

.route-enter-active {
    transition: all 0.3s ease-out;
}

.router-leave-active {
    transition: all 0.3s ease-in;
}

.route-enter-to .route-leave-from {
    opacity: 1;
}
</style>